import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const IndividualniNahradyND = {
	name: NAME,
	apiProvider,
	router,
};
